module.exports = __webpack_public_path__ + "static/img/swiper21.5b3f59df.png";